document.addEventListener('DOMContentLoaded', function () {
    const mobileLabels = {
        'date-desc': 'Newest',
        'date-asc': 'Oldest',
        'title-asc': 'A → Z',
        'title-desc': 'Z → A',
    };

    const urlParams = new URLSearchParams(window.location.search);
    const orderby = urlParams.get('orderby')?.toLowerCase() || 'date';
    const order = urlParams.get('order')?.toLowerCase() || 'desc';
    const currentValue = `${orderby}-${order}`;

    const desktopSelect = document.querySelector('#post-sorting-desktop');
    if (desktopSelect) {
        for (let i = 0; i < desktopSelect.options.length; i++) {
            if (desktopSelect.options[i].value === currentValue) {
                desktopSelect.selectedIndex = i;
                break;
            }
        }

        desktopSelect.addEventListener('change', function () {
            const [newOrderBy, newOrder] = this.value.split('-');
            const url = new URL(window.location.href);
            url.searchParams.set('orderby', newOrderBy);
            url.searchParams.set('order', newOrder);
            window.location.href = url.toString();
        });
    }

    const initMobileSort = () => {
        const mobileButton = document.getElementById('mobile-sort-button');
        const mobileLabel = document.getElementById('mobile-sort-label');
        const optionsList = document.getElementById('mobile-sort-options');
        const optionButtons = optionsList?.querySelectorAll('button[data-sort-value]');

        if (!mobileButton || !mobileLabel || !optionsList) return;

        mobileLabel.textContent = mobileLabels[currentValue] || 'Newest';

        mobileButton.addEventListener('click', () => {
            optionsList.classList.toggle('hidden');
        });

        optionButtons?.forEach(button => {
            button.addEventListener('click', function () {
                const value = this.getAttribute('data-sort-value');
                const [newOrderBy, newOrder] = value.split('-');
                mobileLabel.textContent = mobileLabels[value] || 'Newest';
                optionsList.classList.add('hidden');
                const url = new URL(window.location.href);
                url.searchParams.set('orderby', newOrderBy);
                url.searchParams.set('order', newOrder);
                window.location.href = url.toString();
            });
        });

        document.addEventListener('click', (e) => {
            const wrapper = document.getElementById('mobile-sort-wrapper');
            if (wrapper && !wrapper.contains(e.target)) {
                optionsList.classList.add('hidden');
            }
        });
    };

    const observeEmptyTagsContainers = () => {
        const check = (container) => {
            const terms = container.querySelector('.wp-block-post-terms');
            if (!terms || terms.textContent.trim() === '') {
                container.classList.add('!hidden');
            } else {
                container.classList.remove('!hidden');
            }
        };

        const runCheck = () => {
            document.querySelectorAll('.tags-container').forEach(check);
        };

        const observer = new MutationObserver(runCheck);

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        runCheck();
    };

    const initObservers = () => {
        const sortObserver = new MutationObserver((mutations, obs) => {
            const mobileButton = document.getElementById('mobile-sort-button');
            const mobileLabel = document.getElementById('mobile-sort-label');
            const optionsList = document.getElementById('mobile-sort-options');

            if (mobileButton && mobileLabel && optionsList) {
                initMobileSort();
                obs.disconnect();
            }
        });

        sortObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });

        observeEmptyTagsContainers();
    };

    initObservers();
});
